import { createRootSelector } from "../../../utils/createSelector.js";
/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */
export const gridListColumnSelector = createRootSelector(state => state.listViewColumn);